// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Terms & Services */

.Terms-Services {
    margin-top: 10px;
}

.Terms-Services .Terms-Heading {
    color: var(--black-medium-for-heading, #494949);
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 30px;
}

.Terms-Services .Terms-twoHeading {
    color: var(--black-medium-for-heading, #494949);
    font-size: 25px;
    font-weight: 400;
    margin-top: 30px;
}

.Terms-Services .Para-Terms {
    color: var(--black-low-for-para, #515151);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.6rem;
}

.Terms-Services .list-Terms {
    color: var(--black-low-for-para, #515151);
    font-size: 13px;
}


/* FAQ CSS */

.TeRM-FaQ {
    margin-top: 10px;
}

.TeRM-FaQ .Terms-Heading {
    color: var(--black-medium-for-heading, #494949);
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 30px;
    padding: 0 0px 30px 0px;
}


.TeRM-FaQ .Para-Terms {
    color: var(--black-low-for-para, #515151);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.8rem;
}


/* Policy page shared styling */
.policy-page {
    padding: clamp(2rem, 4vw, 3.5rem) 0 clamp(3rem, 5vw, 4.5rem);
    background: linear-gradient(165deg, var(--bv-bg) 0%, var(--bv-primary-50) 45%, var(--bv-bg-cream) 100%);
}

.policy-shell {
    background: #ffffff;
    border: 1px solid var(--bv-line-soft);
    border-radius: 32px;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.06);
    overflow: hidden;
}

.policy-header {
    padding: clamp(2rem, 3.5vw, 2.75rem);
    border-bottom: 1px solid var(--bv-line-soft);
    background: linear-gradient(135deg, rgba(20, 184, 166, 0.09), rgba(255,255,255,0.95));
}

.policy-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    border-radius: 999px;
    background: var(--bv-primary-50);
    color: var(--bv-primary-700);
    font-size: var(--bv-text-sm);
    font-weight: 600;
    margin-bottom: 1rem;
}

.policy-title {
    font-size: clamp(1.85rem, 2.7vw, 2.6rem);
    font-weight: 800;
    color: var(--bv-ink);
    margin-bottom: 0.5rem;
}

.policy-subtitle {
    color: var(--bv-muted);
    font-size: 1rem;
    line-height: 1.7;
    max-width: 70ch;
}

.policy-content {
    padding: clamp(1.5rem, 3vw, 2.25rem);
    color: var(--bv-ink-2);
}

.policy-content h2,
.policy-content h3,
.policy-content h4 {
    color: var(--bv-ink);
    margin: 1.25rem 0 0.7rem;
}

.policy-content h2 {
    font-size: 1.2rem;
}

.policy-content h3 {
    font-size: 1.05rem;
}

.policy-content h4 {
    font-size: 0.98rem;
}

.policy-content p,
.policy-content li {
    color: var(--bv-muted);
    line-height: 1.8;
}

.policy-content ul {
    padding-left: 1.2rem;
}

.policy-content .steps li {
    margin-bottom: 0.7rem;
}

.policy-content a {
    color: var(--bv-primary-700);
}

.terms-card .terms-block {
    margin-bottom: 1.25rem;
    padding: 1rem 1.1rem;
    border: 1px solid var(--bv-line-soft);
    border-radius: 16px;
    background: var(--bv-bg-soft);
}

.support-box {
    background: linear-gradient(135deg, rgba(20,184,166,0.08), rgba(255,255,255,1));
}


/*   ReturnRefund CSS  */

.Return-Refund {
    margin-top: 10px;
}

.Return-Refund .Terms-Heading {
    color: var(--black-medium-for-heading, #494949);
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 30px;
    padding: 0 0px 30px 0px;
}

.Return-Refund .Para-Terms {
    color: var(--black-low-for-para, #515151);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.8rem;
}

.Return-Refund .Terms-twoHeading {
    color: var(--black-medium-for-heading, #494949);
    font-size: 25px;
    font-weight: 400;
    margin-top: 30px;
}

.Return-Refund .Privacy-three {
    color: var(--black-medium-for-heading, #494949);
    font-size: 20px;
    font-weight: 400;
    margin-top: 30px;
}

.Return-Refund .list-Terms {
    font-size: 13px;
    line-height: 1.7rem;
}

@media(max-width: 767.98px){
    .main-div .Para-Terms{
        font-size: 15px!important;
    }
}

@media screen and (max-width: 575.98px) {
  .main-div {
    padding: 0px 35px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/Terms.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,eAAe;AACnB;;;AAGA,YAAY;;AAEZ;IACI,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;;AAGA;IACI,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA,+BAA+B;AAC/B;IACI,4DAA4D;IAC5D,uGAAuG;AAC3G;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,4CAA4C;IAC5C,qFAAqF;AACzF;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,4BAA4B;IAC5B,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;;;IAGI,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,qCAAqC;IACrC,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,+EAA+E;AACnF;;;AAGA,wBAAwB;;AAExB;IACI,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Terms & Services */\n\n.Terms-Services {\n    margin-top: 10px;\n}\n\n.Terms-Services .Terms-Heading {\n    color: var(--black-medium-for-heading, #494949);\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 30px;\n}\n\n.Terms-Services .Terms-twoHeading {\n    color: var(--black-medium-for-heading, #494949);\n    font-size: 25px;\n    font-weight: 400;\n    margin-top: 30px;\n}\n\n.Terms-Services .Para-Terms {\n    color: var(--black-low-for-para, #515151);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.6rem;\n}\n\n.Terms-Services .list-Terms {\n    color: var(--black-low-for-para, #515151);\n    font-size: 13px;\n}\n\n\n/* FAQ CSS */\n\n.TeRM-FaQ {\n    margin-top: 10px;\n}\n\n.TeRM-FaQ .Terms-Heading {\n    color: var(--black-medium-for-heading, #494949);\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 30px;\n    padding: 0 0px 30px 0px;\n}\n\n\n.TeRM-FaQ .Para-Terms {\n    color: var(--black-low-for-para, #515151);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.8rem;\n}\n\n\n/* Policy page shared styling */\n.policy-page {\n    padding: clamp(2rem, 4vw, 3.5rem) 0 clamp(3rem, 5vw, 4.5rem);\n    background: linear-gradient(165deg, var(--bv-bg) 0%, var(--bv-primary-50) 45%, var(--bv-bg-cream) 100%);\n}\n\n.policy-shell {\n    background: #ffffff;\n    border: 1px solid var(--bv-line-soft);\n    border-radius: 32px;\n    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.06);\n    overflow: hidden;\n}\n\n.policy-header {\n    padding: clamp(2rem, 3.5vw, 2.75rem);\n    border-bottom: 1px solid var(--bv-line-soft);\n    background: linear-gradient(135deg, rgba(20, 184, 166, 0.09), rgba(255,255,255,0.95));\n}\n\n.policy-eyebrow {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 14px;\n    border-radius: 999px;\n    background: var(--bv-primary-50);\n    color: var(--bv-primary-700);\n    font-size: var(--bv-text-sm);\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n.policy-title {\n    font-size: clamp(1.85rem, 2.7vw, 2.6rem);\n    font-weight: 800;\n    color: var(--bv-ink);\n    margin-bottom: 0.5rem;\n}\n\n.policy-subtitle {\n    color: var(--bv-muted);\n    font-size: 1rem;\n    line-height: 1.7;\n    max-width: 70ch;\n}\n\n.policy-content {\n    padding: clamp(1.5rem, 3vw, 2.25rem);\n    color: var(--bv-ink-2);\n}\n\n.policy-content h2,\n.policy-content h3,\n.policy-content h4 {\n    color: var(--bv-ink);\n    margin: 1.25rem 0 0.7rem;\n}\n\n.policy-content h2 {\n    font-size: 1.2rem;\n}\n\n.policy-content h3 {\n    font-size: 1.05rem;\n}\n\n.policy-content h4 {\n    font-size: 0.98rem;\n}\n\n.policy-content p,\n.policy-content li {\n    color: var(--bv-muted);\n    line-height: 1.8;\n}\n\n.policy-content ul {\n    padding-left: 1.2rem;\n}\n\n.policy-content .steps li {\n    margin-bottom: 0.7rem;\n}\n\n.policy-content a {\n    color: var(--bv-primary-700);\n}\n\n.terms-card .terms-block {\n    margin-bottom: 1.25rem;\n    padding: 1rem 1.1rem;\n    border: 1px solid var(--bv-line-soft);\n    border-radius: 16px;\n    background: var(--bv-bg-soft);\n}\n\n.support-box {\n    background: linear-gradient(135deg, rgba(20,184,166,0.08), rgba(255,255,255,1));\n}\n\n\n/*   ReturnRefund CSS  */\n\n.Return-Refund {\n    margin-top: 10px;\n}\n\n.Return-Refund .Terms-Heading {\n    color: var(--black-medium-for-heading, #494949);\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 30px;\n    padding: 0 0px 30px 0px;\n}\n\n.Return-Refund .Para-Terms {\n    color: var(--black-low-for-para, #515151);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.8rem;\n}\n\n.Return-Refund .Terms-twoHeading {\n    color: var(--black-medium-for-heading, #494949);\n    font-size: 25px;\n    font-weight: 400;\n    margin-top: 30px;\n}\n\n.Return-Refund .Privacy-three {\n    color: var(--black-medium-for-heading, #494949);\n    font-size: 20px;\n    font-weight: 400;\n    margin-top: 30px;\n}\n\n.Return-Refund .list-Terms {\n    font-size: 13px;\n    line-height: 1.7rem;\n}\n\n@media(max-width: 767.98px){\n    .main-div .Para-Terms{\n        font-size: 15px!important;\n    }\n}\n\n@media screen and (max-width: 575.98px) {\n  .main-div {\n    padding: 0px 35px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
